import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class LoggedUserService {
    private loggedUserEmail = new BehaviorSubject<string | null>(null);

    setLoggedUserData(data: string | null): void {
        this.loggedUserEmail.next(data);
    }

    getCurrentEmail(): string | null {
        return this.loggedUserEmail.getValue();
    }
}
